import { type ScopedProps, useAccordionContext } from '../../accordion'
import * as S from './content.styles'

type TContentProps = {
  children: React.ReactNode
  index?: number
}

export function Content(props: TContentProps) {
  const { __scopeAccordion, children, index } =
    props as ScopedProps<TContentProps>
  const { expandedIndex } = useAccordionContext(
    'AccordionContent',
    __scopeAccordion
  )
  const isCollapsed = expandedIndex !== index

  return !isCollapsed ? <S.Content>{children}</S.Content> : null
}
